import React, {useEffect, useState} from 'react';
import {IonContent, IonIcon, IonModal, IonPage, IonToast, IonToggle} from '@ionic/react';
import {alertCircleOutline} from 'ionicons/icons';
import {useHistory} from "react-router-dom";
import {ApiService} from "../api/ApiService";
import {toastStore} from "../components/AppToast";
import { Camera } from '@capacitor/camera';
import {UserState, userStore} from "../api/AuthService";
import { DriverProfile } from '../api/model/DriverProfile';
import { base64FromPath } from '@ionic/react-hooks/filesystem';
import leftSide from "../imgs/First_Seated_Photos/left_side.jpeg";
import front from "../imgs/First_Seated_Photos/front.jpeg";
import rightSide from "../imgs/First_Seated_Photos/right_side.jpeg";
import rear from "../imgs/First_Seated_Photos/rear.jpeg";
import cabinFront from "../imgs/First_Seated_Photos/cabin_front.jpeg";
import cabinRear from "../imgs/First_Seated_Photos/cabin_rear.jpeg";
import { config } from '../Constants';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import LoadDetailHeader, { useTransparentHeaderContrast } from '../components/LoadDetailHeader';
import { ChevronRight, CameraIcon, TrashIcon, VehicleIcon } from '../components/icons';

const timages: any[] = [];

interface Photo {
  filepath: string;
  webviewPath?: string;
  data: any;
}

const PHOTO_EXAMPLES = [
  { key: 'left', label: <><b>Left</b> view of the unit</>, src: leftSide, alt: 'Left side of unit' },
  { key: 'front', label: <><b>Front</b> view of the unit</>, src: front, alt: 'Front of unit' },
  { key: 'right', label: <><b>Right</b> view of the unit</>, src: rightSide, alt: 'Right side of unit' },
  { key: 'rear', label: <><b>Rear</b> view of the unit</>, src: rear, alt: 'Rear of unit' },
  { key: 'cabinFront', label: <><b>Front of</b> cabin interior</>, src: cabinFront, alt: 'Cabin front interior' },
  { key: 'cabinRear', label: <><b>Back of</b> cabin interior</>, src: cabinRear, alt: 'Cabin rear interior' },
] as const;

const LeasePurchase: React.FC = () => {

    const history = useHistory();
    const { onSheet, onIonScroll } = useTransparentHeaderContrast();
    const [mounted, setMounted] = useState(false);

    const [images, setImages] = useState<Photo[]>([]);
    const [firstSubmission, setFirstSubmisson] = useState(false)
    const [text, setText] = useState("")
    const [text2, setText2] = useState("")
    const [tractor, setTractor] = useState(0)
    const [checked1, setChecked1] = useState(true);
    const [checked2, setChecked2] = useState(true);
    const [checked3, setChecked3] = useState(true);
    const [checked4, setChecked4] = useState(true);
    const [checked5, setChecked5] = useState(true);
    const [checked6, setChecked6] = useState(true);
    const [checked7, setChecked7] = useState(true);
    const [checked8, setChecked8] = useState(true);
    const [checked9, setChecked9] = useState(true);
    const [checked10, setChecked10] = useState(true);
    const [checked11, setChecked11] = useState(true);
    const [checked12, setChecked12] = useState(true);
    const [checked13, setChecked13] = useState(true);
    const [checked14, setChecked14] = useState(true);
    const [checked15, setChecked15] = useState(true);
    const [checked16, setChecked16] = useState(true);
    const [checked17, setChecked17] = useState(true);
    const [checked18, setChecked18] = useState(true);
    const [checked19, setChecked19] = useState(true);
    const [checked20, setChecked20] = useState(true);
    const [checked21, setChecked21] = useState(true);
    const [checked22, setChecked22] = useState(true);
    const [checked23, setChecked23] = useState(true);
    const [checked24, setChecked24] = useState(true);
    const [checked25, setChecked25] = useState(true);
    const [checked26, setChecked26] = useState(true);
    const [checked27, setChecked27] = useState(true);
    const [checked28, setChecked28] = useState(true);
    const [checked29, setChecked29] = useState(true);
    const [checked30, setChecked30] = useState(true);
    const [checked31, setChecked31] = useState(true);
    const [checked32, setChecked32] = useState(true);

    const [tread1, setTread1] = useState(true)
    const [tread2, setTread2] = useState(true)
    const [tread3, setTread3] = useState(true)
    const [tread4, setTread4] = useState(true)
    const [tread5, setTread5] = useState(true)
    const [tread6, setTread6] = useState(true)
    const [tread7, setTread7] = useState(true)
    const [tread8, setTread8] = useState(true)
    const [tread9, setTread9] = useState(true)
    const [tread10, setTread10] = useState(true)
    const [loading, setShowLoading] = useState(false)
    const [driverName, setDriverName] = useState("")
    const [showPrompt, setShowPrompt] = useState(true)
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [successPhoto, setSuccess] = useState(false);
    const [toast, setToast] = useState<string>("")
    const [openExample, setOpenExample] = useState<string | null>(null);

    const {userInfo}: { userInfo: DriverProfile } = userStore((state: UserState) => ({userInfo: state.driver}));

    enum CameraResultType {
        Uri = 'uri',
        Base64 = 'base64',
        DataUrl = 'dataUrl'
    }

    useEffect(() => {
      const id = requestAnimationFrame(() => {
        setTimeout(() => setMounted(true), 30);
      });
      return () => cancelAnimationFrame(id);
    }, []);

    const isIssue = !checked1 || !checked2 || !checked3 || !checked4 || !checked5 || !checked6 || !checked7 || !checked8 || !checked9 || !checked10 || !checked11 || !checked12 || !checked13 || !checked14 || !checked15 || !checked16 || !checked17 || !checked18 || !checked19 || !checked20 || !checked21 || !checked22 || !checked23 || !checked24 || !checked25 || !checked26 || !checked27 || !checked28 || !checked29 || !checked30 || !checked31 || !checked32;
    let array = [checked1, checked2, checked3, checked4, checked5, checked6, checked7, checked8, checked9, checked10, checked11, checked12, checked13, checked14, checked15, checked16, checked17, checked18, checked19, checked20, checked21, checked22, checked23, checked24]
    let problems = ["Wind Shield", "Fifth Wheel", "Fire Extinguisher", "Headache Rack", "Mirrors", "Body Panels", "Right Side Body Molding", "Curtains", "Sleeper", "Front Bumper", "Grill", "Left Side Body Molding", "Radio", "Tires", "Dash", "Lights", "Platform Science Tablet", "Shifter", "Wheels", "interior Panels", "Air Horn", "Flooring", "Dash Buttons", "Seats"]
    let treadDepth = [tread1, tread2, tread3, tread4, tread5, tread6, tread7, tread8, tread9, tread10]

    let treadItems = [
        {value: tread1, func: setTread1}, {value: tread2, func: setTread2}, {value: tread3, func: setTread3}, {value: tread4, func: setTread4}, {value: tread5, func: setTread5}, {
            value: tread6,
            func: setTread6
        }, {value: tread7, func: setTread7}, {value: tread8, func: setTread8}, {value: tread9, func: setTread9}, {value: tread10, func: setTread10}
    ]

    let boxes = [{value: "Wind Shield", func: setChecked1},
        {value: "Fifth Wheel", func: setChecked2},
        {value: "Fire Extinguisher", func: setChecked3},
        {value: "Headache Rack", func: setChecked4},
        {value: "Mirrors", func: setChecked5},
        {value: "Body Panels", func: setChecked6},
        {value: "Right Side Body Molding", func: setChecked7},
        {value: "Curtains", func: setChecked8},
        {value: "Sleeper", func: setChecked9},
        {value: "Front Bumper", func: setChecked10},
        {value: "Grill", func: setChecked11},
        {value: "Left Side Body Molding", func: setChecked12},
        {value: "Radio", func: setChecked13},
        {value: "Tires", func: setChecked14},
        {value: "Dash", func: setChecked15},
        {value: "Lights", func: setChecked16},
        {value: "Platform Science Tablet", func: setChecked17},
        {value: "Shifter", func: setChecked18},
        {value: "Wheels", func: setChecked19},
        {value: "interior Panels", func: setChecked20},
        {value: "Air Horn", func: setChecked21},
        {value: "Flooring", func: setChecked22},
        {value: "Dash Buttons", func: setChecked23},
        {value: "Seats", func: setChecked24}]


    let received = ["Fuel Card", "Platform Science Tablet", "License Plate", "Decals/Logo", "Contract", "Insurance", "Permit Book", "Received Fire Extinguisher"]
    let receivedValues = [checked25, checked26, checked27, checked28, checked29, checked30, checked31, checked32]
    let receivedItems = [
        {name: "Fuel Card", value: checked25, func: setChecked25}, {name: "Platform Science Tablet", value: checked26, func: setChecked26}, {
            name: "License Plate",
            value: checked27,
            func: setChecked27
        }, {name: "Decals/Logo", value: checked28, func: setChecked28}, {name: "Contract", value: checked29, func: setChecked29}, {
            name: "Insurance",
            value: checked30,
            func: setChecked30
        }, {name: "Permit Book", value: checked31, func: setChecked31}, {name: "Received Fire Extinguisher", value: checked32, func: setChecked32}
    ]

    function fillReport() {
        const unit = 'in'
        const size = 'A4'
        const orientation = 'p'
        const doc = new jsPDF(orientation, unit, size)
        doc.setFontSize(14)

        const driverHeader = [["Driver Name", "Driver Code", "Truck #"]]
        const driverBody = [[driverName, localStorage.getItem("username"), tractor]]


        let issues = ""
        let noissues = ""
        for (let i = 0; i < array.length; i++) {
            if (!array[i]) {
                issues += problems[i] + ", "
            } else {
                noissues += problems[i] + ", "
            }
        }
        let receivedParts = ""
        let didNotReceive = ""
        for (let i = 0; i < received.length; i++) {
            if (receivedValues[i]) {
                receivedParts += received[i] + ", "
            } else {
                didNotReceive += received[i] + ", "
            }
        }

        let treadArray = ""
        for (let i = 0; i < treadDepth.length; i++) {
            if (treadDepth[i]) {
                treadArray += i + 1 + ". Pass\n"
            } else {
                treadArray += i + 1 + ". Fail\n"
            }
        }

        const driverContent = {
            theme: "plain",
            styles: {
                fontSize: 10,
                overflow: 'linebreak'
            },
            startY: 1.6,
            margin: {
                top: 0.1,
                left: 0.1,
                right: 0.1

            },
            head: driverHeader,
            body: driverBody
        }
        const missingOrDamaged = {
            styles: {
                fontSize: 10,
                overflow: 'linebreak'
            },
            margin: {
                top: 0.1,
                left: 0.1,
                right: 0.1

            },
            head: [["Missing or Damaged Parts:"]],
            body: [[issues !== "" ? issues : "N/A"]]
        }
        const noIssue = {
            styles: {
                fontSize: 10,
                overflow: 'linebreak'
            },
            margin: {
                top: 0.1,
                left: 0.1,
                right: 0.1

            },
            head: [["No Issue:"]],
            body: [[noissues !== "" ? noissues : "N/A"]]
        }
        const receivedItems = {
            styles: {
                fontSize: 10,
                overflow: 'linebreak'
            },
            margin: {
                top: 0.1,
                left: 4.2
            },
            head: [["Initialed upon receipt the following items:"]],
            body: [[receivedParts]]
        }
        const didNotReceivedItems = {
            styles: {
                fontSize: 10,
                overflow: 'linebreak'
            },
            margin: {
                top: 0,
                left: 4.2
            },
            head: [["Did not receive:"]],
            body: [[didNotReceive !== "" ? didNotReceive : "N/A"]]
        }
        const treadContent = {
            styles: {
                fontSize: 10,
                overflow: 'linebreak'
            },
            margin: {
                top: 0,
                left: 4.2
            },
            head: [["Tread Depth:"]],
            body: [[treadArray]]
        }
        const notes = {
            theme: "plain",
            headStyles: {fillColor: [248, 248, 248]},
            columnStyles: {0: {fillColor: [248, 248, 248]}},
            styles: {
                fontSize: 10,
                overflow: 'linebreak'
            },
            margin: {
                top: 0.1,
                left: 0.1,
                right: 0.1

            },
            head: [["Notes:"]],
            body: [[text + " " + text2]]
        }
        var logo = new Image()
        logo.src = "/assets/WE_logo-black.png"

        var treadImage = new Image()
        treadImage.src = "/assets/tires.JPG"

        doc.addImage(logo, 2.5, 0)
        doc.text('New Tractor Checklist | Date: ' + new Date().toLocaleDateString().slice(0, 10), 2.2, 1.5)
        autoTable(doc, driverContent)
        autoTable(doc, {...noIssue, startY: (doc as any).lastAutoTable.finalY})
        autoTable(doc, {...missingOrDamaged, startY: (doc as any).lastAutoTable.finalY})
        doc.addImage(treadImage, 0.1, (doc as any).lastAutoTable.finalY, 4, 3)
        autoTable(doc, {...treadContent, startY: (doc as any).lastAutoTable.finalY})
        autoTable(doc, {...receivedItems, startY: (doc as any).lastAutoTable.finalY})
        autoTable(doc, {...didNotReceivedItems, startY: (doc as any).lastAutoTable.finalY})
        autoTable(doc, {...notes, startY: (doc as any).lastAutoTable.finalY})

        const datapath = doc.output("datauristring")
        submitForm(datapath)
        submitReport()

    }

    useEffect(() => {
        ApiService.lpInspectionsGet("Operations", {unit: userInfo.unit!}).then(it => {console.log("unitData in useEffect", it); setFirstSubmisson(false);})
        .catch(err => {console.log("No report found"); setFirstSubmisson(true);})
    }, []);

    async function takePicture() {
      const image = await Camera.getPhoto({
        quality: 30,
        allowEditing: false,
        resultType: CameraResultType.Uri
      });
      const fileName = new Date().getTime() + '.jpeg';
      // await addDateTime(image.webPath!)
      const base64Data = await base64FromPath(image.webPath!);
        console.log("data");
        const newPhotos = [{
          filepath: fileName,
          webviewPath: image.webPath,
          data: base64Data
        }, ...images];
        setImages(newPhotos)
        timages.push(image)
    }

    function createReport() {
        let issues: any = {}
        for (let i = 0; i < array.length; i++) {
            issues[problems[i]] = !array[i]
        }
        issues.comments = text + " " + text2
        issues.isIssue = isIssue

        let receivedItems: any = {}
        for (let i = 0; i < received.length; i++) {
            receivedItems[received[i]] = receivedValues[i]
        }

        let treads: any = {}
        for (let i = 0; i < treadDepth.length; i++) {
            treads[i + 1] = treadDepth[i]
        }

        let report: any = {issues, receivedItems, treads}

        return report;
    }

    const b64toBlob = (base64:any) =>
    fetch(base64).then(res => res.blob())

    async function submitForm(data: string) {
      let tempFile = new Blob([(await b64toBlob(data))], {type: 'application/pdf'})
      ApiService.sendFileEmail("leasePurchase", {
          email: 'lpdocuments@westernexp.com, scarney@westernexp.com',
          subject: 'New Tractor Checklist',
      },
      {
        file1: {
          fileName: "Lease Purchase Form.pdf",
          file: tempFile
        }
      }
      ).then(() => {
          toastStore.getState().setSuccessToast('Thank you! Your form was submitted.');
          history.push('/');
      }).finally(() => setShowLoading(false));
    }

    const submitReport = () => {
        ApiService.lpInspectionSubmission('leasePurchase', {dmCode: userStore.getState().user!.dmcode, unit: tractor, reportData: JSON.stringify(createReport())})
        .then(it => {
            console.log("it", it);
            submitPhotos(it);
        });
    }

    async function submitPhotos(refId: any) {
        // Submit pictures --
        var data = new FormData()
        data.append("payload", JSON.stringify({ cmds: [{cmd: "photoSubmission", args: {driverCode: localStorage.getItem('username')?.toUpperCase(), loginToken: localStorage.getItem('token'), refId: refId.inspectionId, load: "N/A", division: "N/A", trailer: "N/A", unit: tractor, type: "lpInspection", dmCode: "N/A", uploaderType: "app"}}] }))
        const requestOptions = {
        method: 'POST',
        headers: {},
        body: data
        };
        fetch(config.url.BASE_URL, requestOptions)
        .then(response => response.json())
        .then( async () => {uploadPhotos(refId.inspectionId)})
    }

    async function uploadPhotos(refId: any) {
        var data = new FormData();
        data.append("payload", JSON.stringify({ cmds: [{cmd: "photoUpload", args: {loginToken: localStorage.getItem('token'), refId: refId, type: "lpInspection", dmCode: "N/A"}}] }))
        for (let i = 0; i < images.length; i++) {
        data.append(`photos${i}`, new Blob([(await b64toBlob(images[i].data))],{type: 'application/octet-stream'}));
        }
        const requestOptions = {
        method: 'POST',
        body: data
        };
        fetch(config.url.BASE_URL, requestOptions)
        .then(response => response.json())
        .then(json => {if(json.results[0].errmsg){setShowErrorModal(true); setShowLoading(false);}else{setShowLoading(false); setSuccess(true); console.log("photos successful", json.results[0]);}})
    }

    const removePhoto = (e: any) => {
        const name = e.filepath;
        setImages(images.filter(image => image.filepath !== name));
    }

    const goBack = () => {
      history.push('/');
    };

    void showToast;
    void toast;

    const checkList1 = boxes.map((problem, index) => (
        <div className="inspection-row" key={index}>
            <span className={`inspection-row__label${array[index] ? '' : ' inspection-row__label--issue'}`}>
                {problem.value}
                {!array[index] ? <IonIcon icon={alertCircleOutline} /> : null}
            </span>
            <input
                type="checkbox"
                className="inspection-checkbox"
                checked={array[index]}
                onChange={e => problem.func(e.target.checked)}
            />
        </div>
    ))

    const checkList2 = receivedItems.map((item, index) => (
        <div className="inspection-row" key={index}>
            <span className="inspection-row__label">{item.name}</span>
            <IonToggle checked={item.value} color="success" onIonChange={(e) => item.func(e.detail.checked!)}/>
        </div>
    ))

    const checkList3 = treadItems.map((tread, index) => (
        <div className="inspection-row" key={index}>
            <span className="inspection-row__label">{index + 1}. {tread.value ? "Pass" : "Fail"}</span>
            <IonToggle checked={tread.value} color="success" onIonChange={(e) => tread.func(e.detail.checked!)}/>
        </div>
    ))

    return (
        <IonPage>
            <IonModal isOpen={loading} id="transparent">
                <div className="modal-div">
                    <div id="modal">
                        <div className='loading-div'>
                            <p>Please wait... your form is being submitted.</p>
                            <div className="snippet" data-title=".dot-flashing" style={{margin: "4px 16px"}}>
                                <div className="stage">
                                    <div className="dot-flashing"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </IonModal>
            <IonModal isOpen={showPrompt} cssClass="my-custom-class">
                <div className={`design-a design-a--detail${mounted ? ' design-a--mounted' : ''}`} style={{ minHeight: '100%' }}>
                    <div className="home-hero preplan-hero">
                        <div className="safety-hero__badge" aria-hidden="true">
                            <VehicleIcon color="#ffffff" size={26} />
                        </div>
                        <div className="preplan-hero__eyebrow">Trip documentation</div>
                        <div className="preplan-hero__title home-display">Vehicle Inspection</div>
                        <div className="preplan-hero__meta">
                            {firstSubmission ? 'Before you submit' : 'Attention'}
                        </div>
                    </div>
                    <div className="home-sheet preplan-sheet" style={{ paddingBottom: 32 }}>
                        <div className="advance-card">
                            {firstSubmission ? (
                                <>
                                    <div className="advance-card__title">Before you submit</div>
                                    <p className="advance-card__body">
                                        This form is for lease purchase / owner operator drivers, and is for new
                                        tractors only.
                                    </p>
                                    <button type="button" className="profile-submit" onClick={() => setShowPrompt(false)}>
                                        I Understand
                                    </button>
                                </>
                            ) : (
                                <>
                                    <div className="advance-card__title">Attention</div>
                                    <p className="advance-card__body">
                                        You have already submitted this form for this tractor.
                                    </p>
                                    <button type="button" className="profile-submit" onClick={goBack}>
                                        Acknowledge
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </IonModal>

            <LoadDetailHeader title="Vehicle Inspection" onBack={goBack} onSheet={onSheet} />

            <IonToast
                isOpen={successPhoto}
                onDidDismiss={() => {setShowLoading(false); setSuccess(false)}}
                message="Your photos were submitted."
                color="success"
                duration={3000}
            />
            <IonToast
                isOpen={showErrorModal}
                message="Error! One or more photos could not be uploaded, check your connection and please try again."
                color="danger"
                duration={5000}
            />
            <IonContent
              fullscreen
              className="design-a-content design-a-content--light"
              scrollEvents={true}
              onIonScroll={onIonScroll}
            >
              <div className={`design-a design-a--detail${mounted ? ' design-a--mounted' : ''}`}>
                <div className="home-hero photo-hero">
                    <div className="photo-hero__eyebrow">Trip documentation</div>
                    <div className="photo-hero__title home-display">Vehicle Inspection</div>
                    <div className="photo-hero__meta">Lease Purchase Program · New tractor checklist</div>
                </div>

                <div className="home-sheet photo-sheet">
                    <div className="photo-card">
                        <div className="inspection-card__title">Driver &amp; unit</div>
                        <div className="profile-field" style={{ marginTop: 10 }}>
                            <span className="profile-field__label">Tractor Number</span>
                            <input
                                id="tractor"
                                className="profile-field__input"
                                type="number"
                                placeholder="Tractor number"
                                value={tractor !== 0 ? tractor : ""}
                                onChange={e => setTractor(parseInt(e.target.value!, 10))}
                            />
                        </div>
                        <div className="profile-field" style={{ marginTop: 10 }}>
                            <span className="profile-field__label">Full Name</span>
                            <input
                                id="name"
                                className="profile-field__input"
                                type="text"
                                placeholder="Full name"
                                value={driverName}
                                onChange={e => setDriverName(e.target.value!)}
                            />
                        </div>
                    </div>

                    <div className="photo-card">
                        <div className="inspection-card__title">Unit checklist</div>
                        <p className="inspection-card__body">
                            Please review each area, and note damaged or missing parts.
                        </p>
                        <p className="inspection-card__body inspection-card__body--warn">
                            Unchecked items have issues
                        </p>
                        <div className="inspection-list">{checkList1}</div>
                        <div className="profile-field" style={{ marginTop: 12 }}>
                            <span className="profile-field__label">Summary of damage or missing parts</span>
                            <textarea
                                className="profile-field__input"
                                placeholder="Type here"
                                value={text}
                                onChange={e => setText(e.target.value!)}
                            />
                        </div>
                    </div>

                    <div className="photo-card">
                        <div className="inspection-card__title">Received upon delivery</div>
                        <p className="inspection-card__body">
                            Toggle on the items you received with your truck, or from administration.
                        </p>
                        <div className="inspection-list">{checkList2}</div>
                    </div>

                    <div className="photo-card">
                        <div className="inspection-card__title">Tread depth</div>
                        <p className="inspection-card__body">
                            Requirement: 2/32&ndash;4/32 in. Toggled items indicate the tire meets the requirement.
                        </p>
                        <img id="tire-diagram" className="inspection-diagram" src="./assets/tires.JPG" alt="tread depth" />
                        <div className="inspection-list">{checkList3}</div>
                        <div className="profile-field" style={{ marginTop: 12 }}>
                            <span className="profile-field__label">Tires that do not meet the requirement</span>
                            <textarea
                                className="profile-field__input"
                                placeholder="Type here"
                                value={text2}
                                onChange={e => setText2(e.target.value!)}
                            />
                        </div>
                    </div>

                    <div className="photo-card">
                        <div className="inspection-card__title">Unit photos</div>
                        <p className="inspection-card__body">
                            Submit the following six photos. Tap an example to see the angle we need.
                        </p>
                        <div id="rearSideFrontSection" className="photo-examples">
                            {PHOTO_EXAMPLES.map(example => {
                                const isOpen = openExample === example.key;
                                return (
                                    <div key={example.key} className={`photo-example${isOpen ? ' is-open' : ''}`}>
                                        <button
                                            type="button"
                                            className="photo-example__header"
                                            id="current-load-button"
                                            onClick={() => setOpenExample(isOpen ? null : example.key)}
                                            aria-expanded={isOpen}
                                        >
                                            <span className="photo-example__label">{example.label}</span>
                                            <span className={`photo-example__chevron${isOpen ? ' is-open' : ''}`} aria-hidden="true">
                                                <ChevronRight color="oklch(0.55 0.01 260)" />
                                            </span>
                                        </button>
                                        <div className="photo-example__preview">
                                            <img src={example.src} alt={example.alt} />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        {images.length === 0 ? (
                            <p className="photo-empty">No photos yet. Take all six required views.</p>
                        ) : (
                            <div className="photo-grid">
                                {images.map((img, index) => (
                                    <button
                                        key={img.filepath || index}
                                        type="button"
                                        className="photo-thumb"
                                        onClick={() => removePhoto(img)}
                                        aria-label="Remove photo"
                                    >
                                        <img alt="Unit photo" src={img.webviewPath} />
                                        <span className="photo-thumb__remove">
                                            <TrashIcon size={14} />
                                        </span>
                                    </button>
                                ))}
                            </div>
                        )}

                        <button type="button" className="photo-capture" style={{ marginTop: 12 }} onClick={() => takePicture()}>
                            <CameraIcon size={20} />
                            <span>Take photo</span>
                        </button>
                    </div>

                    <div className="photo-card">
                        <div className="inspection-agreement">
                            <IonIcon icon={alertCircleOutline} style={{color: "#c23b2f", fontSize: "22px", flexShrink: 0}} />
                            <p>
                                Legal Agreement. I approve the above information as complete and correct and certify
                                that I am the driver identified above. I further acknowledge and consent to the use
                                of this submission as an electronic signature in accordance with 49 CFR § 390.32 and
                                15 U.S.C. § 7001(c).
                            </p>
                        </div>
                        <button
                            type="button"
                            className="profile-submit"
                            style={{ marginTop: 14 }}
                            onClick={() => {
                                if (driverName !== "" && driverName !== " " && tractor !== 0 && tractor > 0 && images.length > 5) {
                                    setShowLoading(true);
                                    fillReport()
                                } else {
                                    toastStore.getState().setToast('Please include tractor number, name, and 6 photos')
                                }
                            }}
                        >
                            Submit
                        </button>
                    </div>
                </div>
              </div>
            </IonContent>
        </IonPage>
    )
}

export default LeasePurchase;
